import clsx from 'clsx'
import Button from '../Button'
import Modal from '../Modal'
import Typography from '../Typography'
import styles from './unsavedCustomerModal.module.scss'

type UnsavedCustomerModalProps = {
  onClickConfirm: () => void
  onClickCancel: () => void
  onClickClose: () => void
  isLoading?: boolean
  isDisabled?: boolean
  title?: string
  text?: string
  confirmLabel?: string
  cancelLabel?: string
  className?: string
}

const UnsavedCustomerModal = ({
  onClickConfirm,
  onClickCancel,
  onClickClose,
  isLoading = false,
  isDisabled = false,
  title = 'You have Unsaved changes',
  text = 'Your customer has unsaved changes. Save or discard changes to continue.',
  confirmLabel = 'Save Changes',
  cancelLabel = 'Discard',
  className
}: UnsavedCustomerModalProps) => {
  return (
    <Modal
      data-testid="unsaved-modal"
      isOpen
      onClose={onClickClose}
      zIndex={1001}
      isRedesign
      borderStyle="redesign-round"
      disableScrollLock
      className={className}
    >
      <div className={styles.content}>
        <Typography variant="paragraph" className={clsx('heading', styles.title)}>
          {title}
        </Typography>
        <p className={styles.description}>{text}</p>
      </div>

      <div className={styles.controls}>
        <Button
          data-testid="confirm-button"
          loading={isLoading}
          btnType="primary-blue"
          className={styles.confirmButton}
          onClick={onClickConfirm}
          disabled={isLoading || isDisabled}
        >
          {confirmLabel}
        </Button>

        <Button
          data-testid="cancel-button"
          btnType="tertiary"
          className={styles.cancelButton}
          onClick={onClickCancel}
          isRedesign
        >
          {cancelLabel}
        </Button>
      </div>
    </Modal>
  )
}

export default UnsavedCustomerModal
